module.exports = __webpack_public_path__ + "img/Logo_Full_White_Trans.3ff93986.png";